export enum STATES {
  LOADING = "loading",
  LOGGED_OUT = "loggedout",
  LOGGED_IN = "loggedin"
}

export enum FLASH_STATES {
  RECENTLY_VERIFIED_ACCOUNT = "recently_verified"
}

export enum EVENTS {
  LOADING = "event:auth-loading",
  LOGIN_REQUIRED = "event:auth-loginRequired",
  LOGIN_CONFIRMED = "event:auth-loginConfirmed"
}

// Expose enums as globals so other modules can reference them by bare name,
// mirroring the old Grunt concat behaviour where all files shared one scope.
(window as any).STATES = STATES;
(window as any).FLASH_STATES = FLASH_STATES;
(window as any).EVENTS = EVENTS;

export class StateService implements IService {
  private currentState;
  private flashStates = {}; // States that only last until you request them

  constructor(private rootScope: IRootScope, $log) {
    rootScope.$on(EVENTS.LOGIN_REQUIRED, () => {
      $log.info('stateService -> auth:loginRequired -> user is NOT authenticated');

      this.SetState(STATES.LOGGED_OUT);
    });

  }

  public IsLoading() {
    return this.currentState === STATES.LOADING;
  }

  public SetLoading() {
    this.SetState(STATES.LOADING);
    this.rootScope.$broadcast(EVENTS.LOADING);
  }

  public IsLoggedIn() {
    return this.currentState === STATES.LOGGED_IN;
  }

  public SetLoggedIn() {
    this.SetState(STATES.LOGGED_IN);
    this.rootScope.$broadcast(EVENTS.LOGIN_CONFIRMED);
  }

  public IsLoggedOut() {
    return this.currentState === STATES.LOGGED_OUT;
  }

  public SetLoggedOut() {
    this.rootScope.$broadcast(EVENTS.LOGIN_REQUIRED);
  }

  public SetState(state) {
    this.currentState = state;
    console.log(`StateService: ${state}`);
  }

  public GetState() {
    return this.currentState;
  }

  public FlashAccountRecentlyVerified() {
    this.SetFlashState(FLASH_STATES.RECENTLY_VERIFIED_ACCOUNT, true);
  };

  public FlashWasAccountRecentlyVerified() {
    return this.FlashDeleteState(FLASH_STATES.RECENTLY_VERIFIED_ACCOUNT);
  };

  public FlashDeleteState(state) {
    let value = null;

    if (_.has(this.flashStates, state)) {
      value = this.flashStates[state];
      delete this.flashStates[state];
    }
    return value;
  };

  public SetFlashState(state, value) {
    this.flashStates[state] = value;
    console.log(`StateService: flashState: ${state}`);
  };

}

frontendApp.factory("StateService", ["$rootScope", "$log", function($rootScope, $log) {
  return new StateService($rootScope, $log);
}]);
